import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { ComparisonResult } from '../../utils/lotto';
import styles from './HistoryResultDisplay.module.css';

interface Props {
  result: ComparisonResult;
}

const HistoryResultDisplay: React.FC<Props> = ({ result }) => {
  const { bestMatch, fiveMatchCount, fourMatchCount } = result;

  const renderContent = () => {
    if (bestMatch.count === 6) {
      return (
        <>
          <Typography variant="h6" className={styles.highlight}>
            역대 1등 당첨 번호입니다! 🏆
          </Typography>
          <Typography variant="body1">
            {bestMatch.drawNumber}회차에서 동일한 번호가 1등에 당첨된 기록이 있습니다.
          </Typography>
        </>
      );
    }

    if (bestMatch.count === 5) {
      return (
        <>
          <Typography variant="h6">
            5개나 일치하는 강력한 조합이에요! 💪
          </Typography>
          <Typography variant="body1">
            과거 {bestMatch.drawNumber}회차의 3등 당첨 번호와 5개가 일치합니다. (총 {fiveMatchCount}회)
          </Typography>
        </>
      );
    }

    if (bestMatch.count === 4) {
      return (
        <>
          <Typography variant="h6">
            과거와 유사한 조합입니다 🧐
          </Typography>
          <Typography variant="body1">
            역대 당첨 번호와 4개가 일치한 기록이 총 {fourMatchCount}번 있었습니다.
          </Typography>
        </>
      );
    }

    return (
      <>
        <Typography variant="h6">
          새로운 역사를 만들 번호입니다 ✨
        </Typography>
        <Typography variant="body1">
          과거 당첨 이력에서 4개 이상 일치하는 조합을 찾지 못했습니다.
        </Typography>
      </>
    );
  };

  return (
    <Paper elevation={2} className={styles.container}>
      <Box textAlign="center">
        {renderContent()}
      </Box>
    </Paper>
  );
};

export default HistoryResultDisplay;
